@if (crossSellProducts.length>0) {
  <h3 class="upsell-header my-header"><mibp-resource-string key="Cross-sell_component_header"></mibp-resource-string></h3>
}
@if (isLoading) {
  <mibp-loader></mibp-loader>
}

<div  class="columns" [ngClass]="{'hidden': this.isLoading}"  >
  @for (crossSellproduct of crossSellProducts; track crossSellproduct) {
    <div class="column">
      @if (crossSellProducts.length>0) {
        <section class="upsell-card">
          <div class="image-container">
            <a (click)="onClickProductImage(crossSellproduct.code)">
              @if (crossSellproduct.partsPictureImageUrl) {
                <mibp-image [urlOfImage]="crossSellproduct.partsPictureImageUrl"></mibp-image>
              }
              @if (!crossSellproduct.partsPictureImageUrl) {
                <img  src="assets/images/NewDefaultImage.png" alt="image missing">
              }
            </a>
          </div>
          
            <h4 class="item-title" >
              <a (click)="onClickProductImage(crossSellproduct.code)">{{crossSellproduct.name}}</a>
              <mibp-support-team-product-state-menu [productCode]="crossSellproduct.code"></mibp-support-team-product-state-menu>
            </h4>
            
            <div class="upsell-card-info">
              <ul class="item-list">
                <li class="item-name"> <span class="item-label"><mibp-resource-string key="Global_ProductNumber"></mibp-resource-string>: </span> {{crossSellproduct.code}}</li>
                @if (canSeeAvailability) {
                  <li class="item-availability">
                    <span class="item-label"><mibp-resource-string key="Global_ProductAvailability"></mibp-resource-string> 
                  @if (availabilityStateCmp.isLoaded() && availabilityStateCmp.totalAvailability() > 0) {
                    <span  translate="no" class="material-icon material-icon--fill availability-help-icon" (click)="availabilityStateCmp.openPopover($event.target)">help</span>
                  }:</span>
                  <div class="item-availability__wrapper">
                    <!-- TODO: We do not check if this is a rock tool item here-->
                    <mibp-availability-state
                      #availabilityStateCmp
                      [productCode]="crossSellproduct.code"
                      [quantity]="crossSellproduct.quantity"
                      [isRestrictedByAvailability]="crossSellproduct.isRestrictedByAvailability"
                    ></mibp-availability-state>
                  </div>
                </li>
              }
              @if (canSeeExpectedDeliveryDate) {
                <li class="item-availability">
                  <span class="item-label"><mibp-resource-string key="Global_ExpectedDeliveryDate"></mibp-resource-string>: </span>
                  <div class="item-availability__wrapper">
                    <mibp-expected-delivery-date-state
                      [quantity]="crossSellproduct.quantity"
                      [productCode]="crossSellproduct.code"
                      [showRockToolItemMessage]="crossSellproduct.isRockToolItem"
                      [isRestrictedByExpectedDeliveryDate]="crossSellproduct.isRestrictedByExpectedDeliveryDate"
                    ></mibp-expected-delivery-date-state>
                  </div>
                </li>
              }
              <ng-template 
                #priceStateContext="priceStateContext"
                [priceStateContextSource]="priceAndAvailabilitySource"
                [priceStateContext]="crossSellproduct.code" 
                let-showPrice="showPrice">
                @if (showPrice) {
                  <li class="item-price">
                    <mibp-price-state
                      [productCode]="crossSellproduct.code"
                      [source]="priceAndAvailabilitySource"
                      [unitOfMeasure]="crossSellproduct.unitOfMeasure"
                      [isRestrictedByPrice]="crossSellproduct.isRestrictedByPrice"
                    ></mibp-price-state>
                  </li>
                }
              </ng-template>
            </ul>
            <div class="upgrade-btn">
              <button type="button" data-gtm="cross-sell-add-to-cart-btn" class="my-button" (click)="onAddToActiveCart(crossSellproduct)"><mibp-resource-string key="Carts_Active_AddToCartButton"></mibp-resource-string></button>
            </div>
          </div>
        </section>
      }
    </div>
  }
</div>
